// auth-data-manager.service.ts
import { Injectable } from '@angular/core';
import { CustomDataOptions } from 'src/app/model/custom-data-options';
import { LoginService } from 'src/app/services/login.service';
import { CustomDataManager } from './custom-data-manger';

@Injectable({ providedIn: 'root' })
export class AuthDataManagerService {
    constructor(private loginService: LoginService) { }

    getDataManager(options: CustomDataOptions): CustomDataManager {
        const user = this.loginService.getSessionUser();

        const headers = options.headers || [];

        if (user?.['X-Auth-Key']) {
            headers.push({ 'X-Auth-Key': user['X-Auth-Key'] });
        }

        return new CustomDataManager({
            ...options,
            headers,
        });
    }
}
